import Vue from 'vue'
import Vuex from 'vuex'
import basicMutations from './store/basicMutations'
import accountMutations from './store/accountMutations'
import {BlankState} from './store/stateChanges'
import nakdanActions from './store/nakdanActions'
import accountActions from './store/accountActions'
import {initializeFirebase} from './store/firebaseModule'
import {SimpleVsProConfig} from '@/simpleVsProConfig.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: JSON.parse(JSON.stringify(BlankState)),
  mutations: Object.assign(
    {...basicMutations},
    SimpleVsProConfig.IMPLEMENT_USER_ACCOUNTS ? {...accountMutations} : {}
  ),
  actions: Object.assign(
    {...nakdanActions},
    SimpleVsProConfig.IMPLEMENT_USER_ACCOUNTS ? {...accountActions} : {}
  )
})

if (SimpleVsProConfig.IMPLEMENT_USER_ACCOUNTS) initializeFirebase(store)

export default store
